var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNarracao = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    style: {
      enableBackground: "new 0 0 102 102"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:transparent;}\n\t.st1{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51,
    cy: 51,
    r: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.93,19.41c1.19,0.18,2.4,0.32,3.58,0.54c6.5,1.2,12.02,4.21,16.57,9c4.35,4.58,7.02,10.01,7.93,16.23 c1.16,7.96-0.6,15.28-5.19,21.91c-1.77,2.55-3.92,4.76-6.4,6.64c-0.18,0.14-0.35,0.36-0.4,0.57c-1.33,5.5-4.88,9.15-9.76,11.68 c-2.35,1.22-4.85,2.04-7.46,2.51c-1.82,0.33-2.92-0.58-2.93-2.45c-0.01-2.02,0-4.05,0-6.15c-0.59-0.08-1.16-0.15-1.73-0.23 c-6.16-0.82-11.58-3.26-16.22-7.4c-5.02-4.48-8.31-10-9.56-16.6c-1.87-9.84,0.49-18.61,7.14-26.14 c4.82-5.46,10.93-8.64,18.11-9.78c0.88-0.14,1.77-0.23,2.66-0.34C50.49,19.41,51.71,19.41,52.93,19.41z M53.2,83.69 c0.19-0.04,0.35-0.05,0.49-0.11c1.64-0.72,3.37-1.31,4.91-2.21c3.37-1.95,5.64-4.79,6.31-8.72c0.15-0.87,0.62-1.44,1.3-1.95 c7.8-5.89,11.45-13.72,10.67-23.45c-0.59-7.27-3.93-13.22-9.6-17.78c-5.33-4.3-11.49-6.15-18.33-5.61 c-6.39,0.51-11.89,3.04-16.35,7.61c-5.86,6-8.35,13.25-7.28,21.58c1.02,7.94,5.08,14.08,11.73,18.47 c4.06,2.68,8.59,3.99,13.46,4.08c1.95,0.04,2.69,0.78,2.69,2.72C53.2,80.09,53.2,81.87,53.2,83.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.07,43.13c0-1.43,0-2.82,0-4.24c8.64,0,17.24,0,25.9,0c0,1.39,0,2.79,0,4.24 C55.36,43.13,46.74,43.13,38.07,43.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.99,47.55c0,1.44,0,2.82,0,4.24c-8.64,0-17.24,0-25.9,0c0-1.39,0-2.79,0-4.24 C46.7,47.55,55.32,47.55,63.99,47.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,56.19c0,1.43,0,2.82,0,4.24c-4.3,0-8.58,0-12.91,0c0-1.39,0-2.79,0-4.24 C42.36,56.19,46.65,56.19,51,56.19z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNarracao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/narracao.c38205b1.svg";
export { ForwardRef as ReactComponent };